<div class="u-marginBottom-8">
  <b i18n="@@profileView.completionWidget.title">{title, select,
    other {{{ title }}}
  }</b>
  <p *ngIf="group" class="color-grey-300 text-caption">{{ group.name }}</p>
</div>
<p class="u-marginBottom-16 color-grey">
  <ng-container
    i18n="@@profileView.completionWidget.description"
    >{description, select, other {{{ description }}}
  }</ng-container>
</p>
<div fxLayout="row" fxLayoutGap="8px">
  <button
    mat-raised-button
    color="primary"
    (click)="addProfileInformation.emit()"
  >
    <span i18n="@@profileView.completionWidget.ctaText">{ctaText, select,
      other {{{ ctaText }}}
    }</span>
  </button>
  <button *ngIf="canSkip" i18n="@@global.skip" mat-button (click)="skip.emit()">
    Skip
  </button>
</div>
